import { getHashByPrefix } from '../../../domain/common';

let ulCnt = 0;
let liCnt = 0;
let mainTabHash = '';
let subTabHash = '';
window.addEventListener('DOMContentLoaded', (event) => {
    mainTabHash = getHashByPrefix('tab-');//for product page
    if(mainTabHash === 'tab-faq')
        subTabHash =  getHashByPrefix('', 1);
    else {
        mainTabHash = 'use-sub-hash';
        subTabHash = window.location.hash.substring(1);
        }

    //console.log(`mainTabHash: ${mainTabHash} | subTabHash: ${subTabHash}`);

    document.querySelectorAll('ul.collapse').forEach(itemUl => {
        itemUl.setAttribute("id","ul-" + ++ulCnt);
        var hashAffects =  itemUl.getAttribute('hash-affects');

        let lis = itemUl.children;
        liCnt = 0;
        for (var i = 0; i < lis.length; i ++) {/*LI loop*/
            //console.log('lis[i]: ',lis[i]);
            /*Set ID*/
            lis[i].setAttribute("id",`ul-li-${ulCnt}-${++liCnt}`);

            /*Find by HASH*/
            const hashTarget = lis[i].getAttribute('hash-target');
            if(hashTarget && subTabHash !== '' &&  hashTarget === subTabHash){
                //console.log(`hashTarget: ${hashTarget} | subTabHash: ${subTabHash}`);
                lis[i].classList.remove('close');
                lis[i].classList.add('open');

                var parent = lis[i].closest('li.close');
                //console.log('parents el: ',parent);
                while (parent) {
                    parent.classList.remove('close');
                    parent.classList.add('open');
                    parent = parent.closest('li.close');
                }
            }

            /*add CLICK*/
            lis[i].firstChild?.addEventListener('click', event => {
                //console.log(`firstChild: ${event} `);


                event.stopPropagation();
                event.preventDefault();
                const $target = event.target as HTMLInputElement;
                //let liEl =$target.parentElement as HTMLInputElement;
                let liEl = $target.closest("li");

                if(hashAffects !== undefined && hashAffects !== null){
                    window.history.replaceState({}, '', `#${hashTarget}`);
                }

                if (liEl && liEl.classList.contains('open')){
                    liEl.classList.remove('open');
                    liEl.classList.add('close');
                }
                else if (liEl &&liEl.classList.contains('close')){
                    liEl.classList.remove('close');
                    liEl.classList.add('open');
                }
            })
        }
    })
});

export {};